/* ============================================================================
   OSZEA — Cart drawer + cart page engine (SHOPIFY BUILD)
   ---------------------------------------------------------------------------
   Real Shopify Cart AJAX API. No hard-coded products, no hard-coded money.
   Everything product- or threshold-specific arrives in window.OSZEA_CART_CONFIG,
   which snippets/oszea-cart-drawer.liquid renders from live Liquid objects.

   Endpoints used (all standard, no app required):
     GET  {routes.cart_url}.js
     POST {routes.cart_add_url}.js      {items:[{id, quantity, properties}]}
     POST {routes.cart_change_url}.js   {id:<line key>, quantity}

   The free-socks reward line is added/removed here; the $0 comes from a
   Shopify AUTOMATIC DISCOUNT in admin (see README). Never priced in JS.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.OSZEA_CART_CONFIG || {};
  var R = CFG.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change' };
  var busy = false, cart = null, listeners = [];

  /* ----------------------------------------------------------------- money */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    function fix(n, p, t, d) {
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      var int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return parts[1] ? int + d + parts[1] : int;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount_no_decimals': return fix(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fix(cents, 2, ' ', ',');
        default: return fix(cents, 2, ',', '.');
      }
    });
  }
  var money = formatMoney;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, alt, w) {
    if (!src) return '<span class="oc-noimg"></span>';
    var u = src;
    if (u.indexOf('width=') === -1) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300);
    return '<img src="' + esc(u) + '" alt="' + esc(alt || '') + '" loading="lazy">';
  }

  var PATHS = {
    check: '<path d="m5 13 4.5 4.5L19 7"/>',
    truck: '<path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
    gift:  '<path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/><path d="M12 7S10.5 3 8.5 3 6 6 8 7h4Zm0 0s1.5-4 3.5-4S18 6 16 7h-4Z"/>',
    swap:  '<path d="M4 9a8 8 0 0 1 13-3l3 3M20 5v4h-4M20 15a8 8 0 0 1-13 3l-3-3M4 19v-4h4"/>',
    lock:  '<rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
    bag:   '<path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/>',
    plus:  '<path d="M12 5v14M5 12h14"/>',
    spark: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>'
  };
  function ico(name, cls, w) {
    return '<svg class="oc-ico' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="' + (w || 1.8) + '" stroke-linecap="round" stroke-linejoin="round">' + PATHS[name] + '</svg>';
  }
  function tick() { return ico('check', 'oc-tick', 3); }

  /* ------------------------------------------------------------------- api
     parse() surfaces Shopify errors: /cart/*.js answers 422 with a JSON body
     ({status, message, description}) that fetch still resolves. Without this
     an out-of-stock add would look like it succeeded. */
  function parse(r) {
    return r.json().then(function (body) {
      if (r.ok) return body;
      var e = new Error((body && (body.description || body.message)) ||
        'Something went wrong updating your cart. Please try again.');
      e.body = body; e.status = r.status;
      throw e;
    }, function () {
      if (r.ok) return {};
      throw new Error('Something went wrong updating your cart. Please try again.');
    });
  }
  function getCart() {
    return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(parse);
  }
  function addLines(items) {
    return fetch(R.add + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(parse);
  }
  function changeLine(key, quantity) {
    return fetch(R.change + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(parse);
  }

  /* --------------------------------------------------------------- rewards */
  /* A line is the reward ONLY when it carries the _gift property this script
     sets. Matching on variant id alone would flag a pair of socks the customer
     deliberately bought (same variant) as free — and syncGift would then
     delete it below the threshold. */
  function isGift(line) {
    return !!(line.properties && (line.properties._gift === 'true' || line.properties._gift === true));
  }
  function earnedSubtotal() {
    return (cart.items || []).reduce(function (s, l) { return isGift(l) ? s : s + l.final_line_price; }, 0);
  }
  /* CFG.freeShipping/freeSocks are entered by the merchant in the shop's own
     currency (cents). /cart.js totals come back in the customer's presentment
     currency once Markets converts it — comparing raw cents against a converted
     total makes the thresholds fire almost immediately for anyone not browsing
     in the shop's base currency. Shopify.currency.rate is the presentment-per-
     base-currency rate the storefront already uses for every other price on
     the page, so the same conversion is applied here. */
  function currencyRate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return (r && r > 0) ? r : 1;
  }
  function rewards() {
    var rate = currencyRate();
    var shipAt = (CFG.freeShipping || 0) * rate, socksAt = (CFG.freeSocks || 0) * rate, sub = earnedSubtotal();
    return {
      subtotal: sub,
      ship: !shipAt || sub >= shipAt, socks: !!socksAt && sub >= socksAt,
      shipRemain: Math.max(0, shipAt - sub), socksRemain: Math.max(0, socksAt - sub),
      pct: socksAt ? Math.min(100, (sub / socksAt) * 100) : (shipAt ? Math.min(100, (sub / shipAt) * 100) : 100),
      shipAt: shipAt, socksAt: socksAt
    };
  }
  /* Adds / removes the reward line as the threshold is crossed. */
  function syncGift() {
    if (!CFG.giftVariantId || !CFG.freeSocks) return Promise.resolve(false);
    var r = rewards();
    var line = (cart.items || []).filter(isGift)[0];
    if (r.socks && !line) {
      return addLines([{ id: CFG.giftVariantId, quantity: 1, properties: { _gift: 'true' } }])
        .then(getCart).then(function (c) { cart = c; announce('Free socks added.'); return true; });
    }
    if (!r.socks && line) {
      return changeLine(line.key, 0).then(function (c) { cart = c; announce('Free socks removed.'); return true; });
    }
    return Promise.resolve(false);
  }

  /* -------------------------------------------------------- recommendations
     A product is only "already in the cart" because of something the customer
     paid for — the free reward line must not itself hide the module that
     upsells more of that same product (e.g. a second colour of socks). */
  function inCart(id) { return (cart.items || []).some(function (l) { return !isGift(l) && String(l.product_id) === String(id); }); }
  function addons() { return (CFG.addons || []).filter(function (a) { return !inCart(a.productId); }); }
  function pairProduct() {
    var p = CFG.pair;
    return (p && p.variants && p.variants.length && !inCart(p.productId)) ? p : null;
  }

  var picks = {};
  function pick(p) {
    if (!picks[p.productId]) {
      picks[p.productId] = { colour: (p.colours && p.colours[0] && p.colours[0].name) || null, size: null };
    }
    return picks[p.productId];
  }

  /* ============================================================== render */
  function rewardsHTML(r) {
    var msg = !r.ship ? '<b>' + money(r.shipRemain) + '</b> to free shipping'
            : (r.socksAt && !r.socks) ? '<b>' + money(r.socksRemain) + '</b> to free socks'
            : 'All rewards unlocked';
    return '<div class="oc-rw' + (r.socks ? ' is-all' : '') + '">' +
        '<p class="oc-rw-msg">' + (r.socks ? tick() : ico('spark')) + '<span>' + msg + '</span></p>' +
        '<div class="oc-rw-track">' +
          '<div class="oc-rw-fill" style="width:' + r.pct.toFixed(1) + '%"></div>' +
          (r.socksAt ? '<span class="oc-rw-pin' + (r.ship ? ' on' : '') + '" style="left:' +
            ((r.shipAt / r.socksAt) * 100) + '%"></span>' : '') +
          '<span class="oc-rw-pin' + (r.socks ? ' on' : '') + '" style="left:100%"></span>' +
        '</div>' +
        '<div class="oc-rw-marks">' +
          '<span class="' + (r.ship ? 'on' : '') + '">' + ico('truck') + money(r.shipAt) + ' Shipping</span>' +
          (r.socksAt ? '<span class="' + (r.socks ? 'on' : '') + '">' + ico('gift') + money(r.socksAt) + ' Socks</span>' : '') +
        '</div>' +
      '</div>';
  }

  function itemsHTML() {
    return (cart.items || []).map(function (l) {
      var gift = isGift(l);
      var opts = (l.options_with_values || []).filter(function (o) {
        return o.value && o.value !== 'Default Title'; }).map(function (o) {
        return '<span class="oc-opt">' + esc(o.value) + '</span>'; }).join('');
      var qty = gift ? '<span class="oc-giftflag">' + tick() + 'Free reward</span>'
        : '<div class="oc-qty" role="group" aria-label="Quantity for ' + esc(l.product_title) + '">' +
            '<button type="button" data-dec="' + esc(l.key) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span aria-live="polite">' + l.quantity + '</span>' +
            '<button type="button" data-inc="' + esc(l.key) + '" aria-label="Increase quantity">+</button>' +
          '</div>';
      var price = (gift || l.final_line_price === 0)
        ? '<span class="oc-price free">FREE</span><span class="oc-was">' + money(l.original_line_price) + '</span>'
        : '<span class="oc-price">' + money(l.final_line_price) + '</span>' +
          (l.original_line_price > l.final_line_price
            ? '<span class="oc-was">' + money(l.original_line_price) + '</span>' : '');
      return '<div class="oc-item' + (gift ? ' is-gift' : '') + '">' +
          '<a class="oc-media" href="' + esc(l.url) + '">' + img(l.featured_image && l.featured_image.url, l.product_title, 240) + '</a>' +
          '<div class="oc-body">' +
            '<a class="oc-name" href="' + esc(l.url) + '">' + esc(l.product_title) + '</a>' +
            '<div class="oc-opts">' + opts + '</div>' +
            '<div class="oc-itemfoot">' + qty + '<div class="oc-prices">' + price + '</div></div>' +
          '</div>' +
          (gift ? '' : '<button class="oc-rm" type="button" data-rm="' + esc(l.key) + '" aria-label="Remove ' +
            esc(l.product_title) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg></button>') +
        '</div>';
    }).join('');
  }

  /* pack tiers — one tap adds the variant */
  function tierHTML(a) {
    var vs = (a.variants || []).slice(0, 3);
    if (vs.length < 1) return '';
    var save = vs.reduce(function (m, v) {
      return v.compare && v.compare > v.price ? Math.max(m, Math.round((1 - v.price / v.compare) * 100)) : m; }, 0);
    return '<div class="oc-mod">' +
        '<div class="oc-mod-head"><span class="oc-mod-title">' + esc(a.title) + '</span>' +
          (save ? '<span class="oc-save">Save ' + save + '%</span>' : '') + '</div>' +
        (a.line ? '<p class="oc-mod-sub">' + esc(a.line) + '</p>' : '') +
        '<div class="oc-tiers">' + vs.map(function (v) {
          return '<button type="button" class="oc-tier' + (v.best ? ' is-best' : '') + '" data-tieradd="' + v.id + '"' +
            (v.available ? '' : ' disabled') + '>' +
            (v.best ? '<span class="oc-tier-badge">Best value</span>' : '') +
            '<span class="oc-tier-media">' + img(v.image || a.image, a.title, 320) + '</span>' +
            '<span class="oc-tier-name">' + esc(v.label) + '</span>' +
            '<span class="oc-tier-price">' + (v.compare && v.compare > v.price ? '<s>' + money(v.compare) + '</s>' : '') +
              '<b>' + money(v.price) + '</b></span>' +
            '<span class="oc-tier-add">' + (v.available ? ico('plus', '', 2.2) + 'Add' : 'Sold out') + '</span>' +
          '</button>'; }).join('') + '</div>' +
      '</div>';
  }

  function pairHTML() {
    var p = pairProduct();
    if (!p) return '';
    var s = pick(p);
    var sizes = (p.sizes || []).map(function (z) {
      var v = variantFor(p, s.colour, z);
      return { label: z, available: !!(v && v.available) };
    });
    var chosen = variantFor(p, s.colour, s.size);
    /* A colour can be selected before a size. Use the first variant for that
       colour as the visual source so the large recommendation thumbnail reacts
       immediately, while `chosen` remains responsible for price/availability. */
    var visual = chosen || variantFor(p, s.colour, null);
    var ready = !!(chosen && chosen.available);
    return '<div class="oc-mod">' +
      '<div class="oc-mod-head"><span class="oc-mod-title">' + esc(p.heading || 'Perfect pair') + '</span></div>' +
      '<div class="oc-pair" data-pair="' + esc(p.productId) + '">' +
        '<div class="oc-pair-top">' +
          '<a class="oc-pair-media" href="' + esc(p.url) + '">' + img((visual && visual.image) || p.image, p.title, 320) + '</a>' +
          '<div><a class="oc-pair-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="oc-pair-price">' + money(chosen ? chosen.price : p.price) + '</div>' +
            ((p.colours || []).length > 1 ? '<div class="oc-swatches" role="radiogroup" aria-label="Colour">' +
              p.colours.map(function (c) {
                /* No real swatch colour configured in admin for this value (hex falls
                   back to grey) — show the variant's own product photo instead of a
                   meaningless grey dot, so colours stay distinguishable either way. */
                var useImg = c.image && (!c.hex || c.hex.toLowerCase() === '#cccccc');
                return '<button type="button" class="oc-sw' + (useImg ? ' has-img' : '') + '" role="radio" aria-checked="' + (c.name === s.colour) +
                  '" aria-label="' + esc(c.name) + '" data-colour="' + esc(c.name) + '"' +
                  (useImg ? '' : ' style="background:' + esc(c.hex || '#ccc') + '"') + '>' +
                  (useImg ? '<img src="' + esc(c.image) + '" alt="">' : '') + '</button>'; }).join('') + '</div>' : '') +
          '</div>' +
        '</div>' +
        '<div class="oc-pair-body">' +
          '<div class="oc-sizes" role="radiogroup" aria-label="Size">' + sizes.map(function (z) {
            return '<button type="button" class="oc-size" role="radio" aria-checked="' + (z.label === s.size) +
              '" data-size="' + esc(z.label) + '"' + (z.available ? '' : ' disabled aria-disabled="true"') + '>' +
              esc(String(z.label).replace(/^(UK|US|AU)\s/, '')) + '</button>'; }).join('') + '</div>' +
          '<button type="button" class="oc-add" data-pairadd="' + (chosen ? chosen.id : '') + '"' +
            (ready ? '' : ' disabled') + '>' +
            (ready ? ico('plus', '', 2.2) + 'Add — ' + money(chosen.price) : 'Select a size') + '</button>' +
        '</div>' +
      '</div></div>';
  }
  function variantFor(p, colour, size) {
    return (p.variants || []).filter(function (v) {
      return (!colour || v.colour === colour) && (!size || String(v.size) === String(size)); })[0];
  }

  function emptyHTML() {
    return '<div class="oc-empty"><div class="oc-empty-ico">' + ico('bag') + '</div>' +
      '<h3>Your cart is empty</h3><p>Forget the forecast — pick a pair.</p>' +
      '<a class="btn btn-primary" href="' + esc(CFG.shopUrl || '/collections/all') + '">Shop footwear ' +
      '<span class="arw">&rarr;</span></a></div>';
  }

  /* --------------------------------------------------------------- paint */
  function paint() {
    var r = rewards(), empty = !(cart.items || []).length;
    var body = empty ? emptyHTML()
      : rewardsHTML(r) + '<div class="oc-items">' + itemsHTML() + '</div>' +
        addons().map(tierHTML).join('') + pairHTML();

    var dScroll = document.getElementById('ocDrawerScroll');
    if (dScroll) {
      dScroll.innerHTML = body;
      var foot = document.getElementById('ocDrawerFoot');
      if (foot) foot.hidden = empty;
    }
    var pMain = document.getElementById('ocPageMain');
    if (pMain) {
      pMain.innerHTML = empty ? '<div class="oc-card">' + emptyHTML() + '</div>'
        : '<div class="oc-card">' + rewardsHTML(r) + '</div>' +
          '<div class="oc-card"><div class="oc-items">' + itemsHTML() + '</div></div>' +
          '<div class="oc-card">' + addons().map(tierHTML).join('') + pairHTML() + '</div>';
      var side = document.getElementById('ocPageSide'); if (side) side.hidden = empty;
      var mobar = document.getElementById('ocMobar'); if (mobar) mobar.hidden = empty;
    }

    var gross = (cart.items || []).reduce(function (s, l) { return s + l.original_line_price; }, 0);
    document.querySelectorAll('[data-oc-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
    document.querySelectorAll('[data-oc-gross]').forEach(function (el) { el.textContent = money(gross); });
    document.querySelectorAll('[data-oc-count]').forEach(function (el) {
      el.textContent = cart.item_count; el.classList.toggle('show', cart.item_count > 0); });
    document.querySelectorAll('[data-oc-count-paren]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    document.querySelectorAll('[data-oc-count-label]').forEach(function (el) {
      el.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items'); });
    /* single source of truth for the "free shipping over X" copy — computed
       here (currency-converted) instead of duplicated as a Liquid constant
       in both the drawer snippet and the /cart page section */
    document.querySelectorAll('[data-oc-shipnote]').forEach(function (el) { el.textContent = money(r.shipAt); });

    var st = document.getElementById('ocSumStatus');
    if (st) {
      st.classList.toggle('is-all', r.ship && r.socks);
      st.innerHTML = statRow(r.ship, r.ship ? 'Free shipping unlocked' : money(r.shipRemain) + ' to free shipping') +
        (r.socksAt ? statRow(r.socks, r.socks ? 'Free socks unlocked' : money(r.socksRemain) + ' to free socks') : '');
    }
    var disc = document.getElementById('ocSumDisc');
    if (disc) {
      var g = (cart.items || []).filter(isGift)[0];
      disc.hidden = !g;
      if (g) disc.querySelector('.v').textContent = '−' + money(g.original_line_price);
    }
    /* keep the theme's own cart bubble in sync */
    (CFG.themeCountSelectors || []).forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; });
    });
    document.dispatchEvent(new CustomEvent('oszea:cart-updated', { detail: cart }));
    listeners.forEach(function (f) { f(cart); });
  }
  function statRow(on, text) {
    return '<div class="oc-stat' + (on ? ' on' : '') + '"><span class="dot">' + (on ? tick() : '') + '</span>' + esc(text) + '</div>';
  }
  function announce(msg) { var l = document.getElementById('ocLive'); if (l) l.textContent = msg; }

  /* Every refresh runs to completion before the next starts. syncGift() adds or
     removes the reward line, so two refreshes in flight at once (open + quick-add)
     could each see "no gift yet" and both POST it — charging the customer for a
     second pair. The chain also absorbs failures so one bad fetch can't wedge it. */
  var refreshChain = Promise.resolve();
  function doRefresh() {
    /* syncGift() already leaves `cart` at the post-change state — both
       /cart/add.js (it fetches after adding) and /cart/change.js (whose
       response IS the full cart) — so there is nothing left to re-fetch. */
    return getCart().then(function (c) { cart = c; return syncGift(); })
      .then(function () { paint(); })
      .catch(function (err) { announce((err && err.message) || 'Your cart could not be updated.'); });
  }
  function refresh() {
    refreshChain = refreshChain.then(doRefresh, doRefresh);
    return refreshChain;
  }

  /* -------------------------------------------------------- drawer control
     Closes on: click/tap anywhere outside the panel, Esc, "Continue shopping". */
  var lastTrigger = null;
  function openDrawer(trigger) {
    var d = document.getElementById('ocDrawer'); if (!d) return;
    lastTrigger = (trigger && trigger.focus) ? trigger : document.activeElement;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); d.removeAttribute('inert');
    document.body.classList.add('oc-locked');
    var panel = d.querySelector('.oc-panel'); if (panel) setTimeout(function () { panel.focus(); }, 60);
    refresh();
  }
  function closeDrawer() {
    var d = document.getElementById('ocDrawer'); if (!d) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('oc-locked');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    /* after focus has left the panel, take it out of the a11y + tab tree */
    d.setAttribute('inert', '');
  }
  function isOpen() { var d = document.getElementById('ocDrawer'); return !!(d && d.classList.contains('open')); }

  document.addEventListener('pointerdown', function (e) {
    if (isOpen() && !e.target.closest('.oc-panel')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = document.getElementById('ocDrawer').querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) {
      return el.offsetWidth || el.offsetHeight || el === document.activeElement; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------ delegation */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('button,a');
    if (!t) return;

    /* let the browser handle open-in-new-tab / new-window gestures */
    var modified = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1;

    /* open triggers: our own, plus the theme's cart icon/link */
    if (t.matches('[data-oc-open]') || (CFG.openSelectors || []).some(function (s) { return t.matches(s); }) ||
        (CFG.interceptCartLinks !== false && t.matches('a[href$="/cart"],a[href*="/cart?"]'))) {
      if (modified && t.tagName === 'A' && t.getAttribute('href')) return;
      e.preventDefault(); openDrawer(t); return;
    }
    if (t.matches('[data-oc-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (busy || !cart) return;

    var inc = t.getAttribute('data-inc'), dec = t.getAttribute('data-dec'), rm = t.getAttribute('data-rm');
    if (inc || dec || rm) {
      var key = inc || dec || rm;
      var line = (cart.items || []).filter(function (l) { return l.key === key; })[0];
      if (!line) return;
      busy = true; t.disabled = true;
      changeLine(key, rm ? 0 : (inc ? line.quantity + 1 : line.quantity - 1))
        .then(function (c) { cart = c; return refresh(); })
        .then(function () { busy = false; t.disabled = false; announce('Cart updated. Subtotal ' + money(cart.total_price) + '.'); })
        .catch(function (err) { busy = false; t.disabled = false; announce((err && err.message) || 'Could not update the cart.'); });
      return;
    }

    if (t.hasAttribute('data-tieradd') || t.hasAttribute('data-pairadd')) {
      var id = t.getAttribute('data-tieradd') || t.getAttribute('data-pairadd');
      if (!id) return;
      busy = true; t.classList.add('done');
      addLines([{ id: Number(id), quantity: 1 }])
        .then(function () { return refresh(); })
        .then(function () { busy = false; if (!isOpen()) openDrawer(); announce('Added. Subtotal ' + money(cart.total_price) + '.'); })
        .catch(function (err) { busy = false; t.classList.remove('done'); announce((err && err.message) || 'Could not add that item.'); });
      return;
    }

    var pairBox = t.closest('[data-pair]');
    if (pairBox && CFG.pair) {
      var s = pick(CFG.pair);
      if (t.hasAttribute('data-colour')) { s.colour = t.getAttribute('data-colour'); paint(); return; }
      if (t.hasAttribute('data-size') && !t.disabled) { s.size = t.getAttribute('data-size'); paint(); return; }
    }
  });

  /* ------------------------------------------- product forms -> AJAX + open
     Opt-in only: a form must carry data-oc-ajax, OR the store must set
     CFG.ajaxProductForms = true. Leave it false on themes that already submit
     their add-to-cart forms over AJAX (Dawn's <product-form> does) — otherwise
     both handlers fire and the item is added twice. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (!CFG.ajaxProductForms && !form.hasAttribute('data-oc-ajax')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('loading'); btn.disabled = true; }
    fetch(R.add + '.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(parse)
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); })
      .catch(function (err) { announce((err && err.message) || 'Could not add to cart.'); })
      .finally(function () { if (btn) { btn.classList.remove('loading'); btn.disabled = false; } });
  });

  document.addEventListener('oszea:open-cart', function () { openDrawer(); });

  /* --------------------------------------------------------------- public */
  window.OSZEA_CART = {
    open: openDrawer, close: closeDrawer, refresh: refresh, money: money,
    get state() { return cart; },
    addVariant: function (id, quantity, properties) {
      return addLines([{ id: Number(id), quantity: quantity || 1, properties: properties }])
        .then(function () { return refresh(); }).then(function () { openDrawer(); });
    },
    onChange: function (fn) { listeners.push(fn); }
  };

  function boot() { if (document.getElementById('ocDrawer') || document.getElementById('ocPageMain')) refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
